import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  environment: string;

  constructor(private router: Router) {
    this.environment = this.getEnvironmentFromUrl();
  }

  private getEnvironmentFromUrl(): string {
    const url = window.location.origin;
    if (url.indexOf('localhost') > 0) {
      return 'local';
    } else if (url.indexOf('egis-ekstern.test') > 0) {
      return 'test';
    } else if (url.indexOf('egis-ekstern.prodtest') > 0) {
      return 'prodtest';
    } else if (url.indexOf('egis-ekstern.ok.dk') > 0) {
      return 'prod';
    }
    return '';
  }

  isProd(): boolean {
    const url = window.location.origin;
    if (url.indexOf('ekstern-egis.ok.dk') > 0) {
      return true;
    }
    return false;
  }
}
